import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ccd-activity-banner',
  template: require('./activity-banner.component.html'),
  styles: [require('./activity-banner.component.css')]
})
export class ActivityBannerComponent implements OnInit {
  @Input()
  public bannerType: string;

  @Input()
  public description: string;

  @Input()
  public imageLink: string;

  constructor() { }

  ngOnInit() {
  }
}
